<template>
    <div class="mb-3">
        <label class="form-label" v-if="label">{{ label }}</label>

        <div class="d-flex align-items-center">
            <!-- Custom Toggle Switch -->
            <label class="switch-container">
                <input type="checkbox" :name="name" :id="id" :checked="modelValue" @change="handleChange" />
                <span class="slider"></span>
            </label>

            <label class="form-check-label ms-2" :class="textColor" :style="`color:${textColor}; cursor: pointer;`"
                :for="id">
                {{ text }}
            </label>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'DynamicToggle',
    props: {
        label: { type: String },
        text: { type: String },
        modelValue: { type: [Boolean, Number], default: false },
        name: { type: String },
        id: { type: String },
        textColor: { type: String }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const handleChange = (event) => {
            const newValue = event.target.checked ? 1 : 0;
            emit('update:modelValue', newValue);
        };

        return { handleChange };
    }
});
</script>

<style scoped>
/* تصميم الـ Toggle Switch الاحترافي بحال الصورة */
.switch-container {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
    margin-bottom: 0;
    cursor: pointer;
}

.switch-container input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .3s;
    border-radius: 24px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
}

input:checked+.slider {
    background-color: #186696; 
}

input:checked+.slider:before {
    transform: translateX(24px);
}
</style>